export const editorGrid = {
  x: 46,
  y: 64,
  nodeHeight: 54,
};
